module.exports = __webpack_public_path__ + "img/report_main.44d1460f.png";